export const MealPlanSwap = {
  bindings: {
    recipe: '<',
    selected: '<',
    onSwap: '&',
    onPreview: '&',
  },

  template: `
    <div class="meal-plan-swap card-wrapper"
      ng-class="{ 'theme-border': $ctrl.recipe.id === $ctrl.selected.id }">
      <card
        heading="$ctrl.recipe.name"
        img="$ctrl.recipe.imageUrl.magazine"
        ng-click="$ctrl.onSwap()">
      </card>
      <button class="meal-plan-preview btn btn-link w-100"
        type="button"
        ng-click="$ctrl.onPreview()">
        Preview
      </button>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanSwap.js